import React from 'react'
import Header from '../components/Header'
import locale from '../locale'
import Hero from '../components/Hero'
import en from '../locale/en'
import cn from '../locale/cn'
import Layout from '../components/Layout'
import Footer from '../components/Footer'
import SectionHeader from '../components/SectionHeader'
import SubsectionHeader from '../components/SubsectionHeader'
import InfoBlockGrid from '../components/InfoBlockGrid'
import ImageGrid from '../components/ImageGrid'
import LinkBox from '../components/LinkBox'
import Img from 'gatsby-image'
import { graphql } from 'gatsby'
import './page.css'

let data = { en, cn };
let localizedData = () => data[locale.getLocale()];
let header_data = localizedData().header;
let sponsors_and_partners_data = localizedData().sponsors_and_partners;
let isShort = true;

class SponsorsAndPartnersPage extends React.Component {

    constructor(props) {
      super(props);

      this.state = {
        isShiftedLeft: false,
      }

      this.shiftLeft = this.shiftLeft.bind(this);
      this.shiftRight = this.shiftRight.bind(this);
    }

    shiftLeft() {
      this.setState({isShiftedLeft: true});
    }

    shiftRight() {
      this.setState({isShiftedLeft: false});
    }

    render() {
      return (
        <div className={"page " + (this.state.isShiftedLeft ? "left-shift" : "neutral-shift")}>
        <Layout>
        <Header
          onBMOpen={this.shiftLeft}
          onBMClose={this.shiftRight}
          fluid={this.props.data.logoImage.childImageSharp.fluid}
          data={header_data}>
        </Header>

        <Hero
          isShort = {isShort}
          fluid = {this.props.data.heroImage.childImageSharp.fluid}
          data={sponsors_and_partners_data.hero}>
        </Hero>


        <div className="cropped-width">

        <SectionHeader
          data={sponsors_and_partners_data.sponsorships}></SectionHeader>

        <InfoBlockGrid
          data={sponsors_and_partners_data.tiers}
          nCellsPerRow={2}
          nCellsPerRowMobile={1}
          isCentered={true}></InfoBlockGrid>

        <SectionHeader
          data={sponsors_and_partners_data.partnerships}></SectionHeader>

        <SectionHeader data = {sponsors_and_partners_data.sponsors}></SectionHeader>
        <ImageGrid
          nCellsPerRow={3}
          nCellsPerRowMobile={2}
          images={this.props.data.sponsorsImages.edges}></ImageGrid>
        <SectionHeader data = {sponsors_and_partners_data.supporting_organizations}></SectionHeader>
        <ImageGrid
          nCellsPerRow={3}
          nCellsPerRowMobile={2}
          images={this.props.data.supportingOrganizationsImages.edges}></ImageGrid>

        </div>
        </Layout>

        <Footer></Footer>

      </div>
    )
  }
}

export default SponsorsAndPartnersPage;

export const pageQuery = graphql`
  query SponsorsAndPartnersQuery {
    logoImage: file(relativePath: { eq: "logo_white.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    },
    heroImage: file(relativePath: { eq: "scholarship-fund/hero.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    },
    underwriteImage: file(relativePath: { eq: "scholarship-fund/underwrite_a_section.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    },
    sponsorsImages: allFile(filter: { relativeDirectory: { eq: "sponsors-and-partners/sponsors" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    },
    supportingOrganizationsImages: allFile(filter: { relativeDirectory: { eq: "sponsors-and-partners/supporting_organizations" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    },
  }
`;
